import React, { useEffect, useState } from "react";
import axiosInstance from '../../../../axiosInstance';
import { API_URL } from "../../../../config";
import { NavLink, useNavigate } from "react-router-dom";
import JobZImage from "../../../common/jobz-img";
import { employer, empRoute } from "../../../../globals/route-names";

function EmpCandidatesPage() {
    const navigate = useNavigate();
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [imgError, setImgError] = useState(false);
    const [dataTable, setDataTable] = useState(null);

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "active": return "green";
            case "pending": return "blue";
            case "inactive": return "red";
            default: return "gray";
        }
    };
    const fetchCandidates = async () => {
        // debugger;
        try {
            const response = await axiosInstance.get(`${API_URL}/admin/candidate-list`);
            if (response.data.status === 200) {
                setCandidates(response.data.data);
            }
        } catch (err) {
            console.error("Error fetching candidates", err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchCandidates();
    }, []);

    useEffect(() => {
        let dataTable = null;
        if (!loading && candidates.length > 0) {
            const $ = window.$;
            // Destroy existing DataTable if it exists
            if ($.fn.DataTable.isDataTable('#subscription_table')) {
                $('#subscription_table').DataTable().destroy();
            }

            // Initialize new DataTable
            dataTable = $('#subscription_table').DataTable({
                responsive: true,
                searching: true,
                ordering: true,
                paging: true,
                pageLength: 10,
                destroy: true,
                autoWidth: false,
                dom: 'Bfrtip',
                language: {
                    search: "Search:",
                    searchPlaceholder: "Search candidates...",
                    emptyTable: "No candidates available",
                    zeroRecords: "No matching candidates found"
                },
                columnDefs: [
                    { orderable: false, targets: [6] }, // Disable sorting for Actions column
                    { searchable: false, targets: [6] } // Disable searching for Actions column
                ],
                order: [[0, 'asc']], // Sort by Package Name by default
                drawCallback: function () {
                    // Reinitialize tooltips after table draw
                    $('[data-bs-toggle="tooltip"]').tooltip();
                }
            });
        }
        // Cleanup function
        return () => {
            if (dataTable) {
                dataTable.destroy();
            }
        };
    }, [loading, candidates]);

    const handleEdit = async (id) => {
        try {
            const response = await axiosInstance.get(`${API_URL}/admin/candidate-detail/${id}`);
            if (response.data.status === 200) {
                const candidateData = response.data.data;
                navigate("/employer/candidates-edit", {
                    state: { candidate: candidateData }
                });
            } else {
                alert("Failed to fetch candidate details.");
            }
        } catch (error) {
            console.error("Error fetching candidate detail", error);
            alert("Something went wrong!");
        }
    };

    return (
        <>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Candidates</h2>
                <div className="breadcrumbs"><a href="#">Home</a><a href="#">Dashboard</a><span>Candidates</span></div>
            </div>
            <div className="twm-pro-view-chart-wrap">
                <div className="col-lg-12 col-md-12 mb-4">
                    <div className="panel panel-default site-bg-white m-t30">
                        <div className="panel-heading wt-panel-heading p-a20 d-flex justify-content-between align-items-center">
                            <h4 className="panel-tittle m-a0"><i className="far fa-list-alt" />All Candidates</h4>
                            <NavLink to={empRoute(employer.CANDIDATE_ADD)}>
                                <button className="site-button m-r5">
                                    Add Candidate
                                </button>
                            </NavLink>
                        </div>
                        <div className="panel-body wt-panel-body">
                            <div className="twm-D_table p-a20 table-responsive">
                                <table id="subscription_table" className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Mobile</th>
                                            <th>Signup By</th>
                                            <th>CV</th>
                                            <th>Status</th>
                                            <th>Created At</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!loading && candidates.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.id || '-'}</td>
                                                <td>
                                                    <div className="twm-DT-candidates-list">
                                                        <div className="twm-media">
                                                            <div className="twm-media-pic">
                                                                {item?.photo_url && !imgError ? (
                                                                    <img
                                                                        src={item.photo_url}
                                                                        alt="Profile"
                                                                        className="w-full h-auto rounded-full"
                                                                        onError={() => setImgError(true)}
                                                                    />
                                                                ) : 
                                                                (
                                                                    <JobZImage src="images/user-avtar/pic4.jpg" alt="Profile" />
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="twm-mid-content">
                                                            <a href="#" className="twm-job-title">
                                                                <h4>{item.first_name} {item.last_name}</h4>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{item.email || '-'}</td>
                                                <td>{item.mobile || '-'}</td>
                                                <td>{item.signup_by || '-'}</td>
                                                <td>
                                                    {item.cv_file ? (
                                                        <a
                                                            href={`${API_URL}/app/uploads/${item.cv_file}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-sm btn-primary"
                                                        >
                                                            CV
                                                        </a>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="twm-jobs-category">
                                                        <span className={`twm-bg-${getStatusColor(item.status)}`}>
                                                            {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>{new Date(item.created_at).toLocaleDateString()}</td>
                                                <td>
                                                    <div className="twm-table-controls">
                                                        <ul className="twm-DT-controls-icon list-unstyled">
                                                            <li>
                                                                <button
                                                                    title="Edit"
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-placement="top"
                                                                    onClick={() => handleEdit(item.id)}
                                                                    className="btn btn-sm"
                                                                >
                                                                    <span className="far fa-edit" />
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <th>Id</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Mobile</th>
                                            <th>Signup By</th>
                                            <th>CV</th>
                                            <th>Status</th>
                                            <th>Created At</th>
                                            <th>Actions</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmpCandidatesPage;
